import { ELEMENT_VIEWED } from '../../actions/elementsViewedActions';

const ElementsViewedReducer = (state = [], action) => {
    Object.freeze(state);
    const newState = Array.from(state);

    switch (action.type) {
        case ELEMENT_VIEWED:
            newState.push(action.element);
            return newState;

        default:
            return state;
    }
};

export default ElementsViewedReducer;
